/*BudgetCast*/
import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { NotificationService } from "app/shared/utils/notification.service";
import { ValidationMessage } from "app/validation/ValidationMessage";
import { ApiResponseError } from '../../client-core/api-response-models';


@Component({
    selector: 'app-validation-summary',
    templateUrl: './validation-summary.component.html'
})
export class ValidationSummary implements OnInit, OnChanges {
    @Input() messages: ValidationMessage;
    
    constructor(private notificationService: NotificationService) {
        this.messages = new ValidationMessage(new Array<ApiResponseError>());
    }

    ngOnInit() {

    }

    ngOnChanges() {
        if (this.messages && this.messages.displayInBox) {
            let htmlContent = '';
            this.messages.messages.forEach((str) => {
                htmlContent = `${htmlContent}<p>${str}</p>`;
            });

            this.notificationService.bigBox({
                title: this.messages.displayTitle,
                content: htmlContent,
                color: this.messages.displayType === "success" ? "#739E73" : "#c26565",
                icon: this.messages.displayType == "success" ? "fa fa-check shake animated" : "fa fa-warning shake animated",
                timeout: this.messages.hidefterSeconds * 1000
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/validation/validation-display/validation-summary.component.ts